import React, { useState, useEffect } from 'react';
import { CopyToClipboard } from "react-copy-to-clipboard";
import country_currency from "./country_currency.json";
import API from './API';


function Jobposting() {
  const [copied, setCopied] = React.useState(false);   
  const [countryData, setCountryData]= useState([]);
  const [stateData, setStateData]= useState([]);
  const [checked, setChecked] = React.useState(false);
  const [isTrueCompanyurl, setCompanyUrl] = useState(false);

  useEffect(() => {
    API.getCountryState().then((response) => {
      setCountryData(response.data);
    });
  }, []);

  const handleChangeCheckbox = () => { 
    setChecked(!checked);
  };
  const hiringOrganization = {
    "hiringOrganization" : {
      "@type": "Organization",
      "name": "company name",
      "sameAs": "https://projects.zoho.in/",
      "logo": "https://projects.zoho.in//"
    }
  };

  const applicantLocationRequirements = {
    "applicantLocationRequirements": {
      "@type": "Country",
      "name": "IN"
    }
  };
   
  const [basesalayData, setBasesalaryData] = useState({
    currency:'',
    maxsalary:'',
    minsalary:'',
    unitText:'',
  }); 
  const [inputFieldsJp, setInputFieldsJp] = useState({
      type: "JobPosting",
      job_title: '',
      description:'',
      hiringOrganization,   
      industry:'',
      employmentType:'',
      workHours:'',
      datePosted:'',
      validThrough:'',
      applicantLocationRequirements,
      jobLocationType:'',
      jobLocation: {
        "@type": "Place",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "",
          "addressLocality": "",
          "postalCode": "",
          "addressCountry": ""
        }
      } ,
      baseSalary: {
        "@type": "MonetaryAmount",
        "currency": "",
        "value": {
          "@type": "QuantitativeValue",
          "minValue": 0,
          "maxValue": 0,
          "unitText": ''
        }
      },
      responsibilities:'',
      skills:'',
      qualifications:'',
      educationRequirements:'',
      experienceRequirements:'',
      street: "",
      city: "",
      zipcode: "",
      country: "",
      state:'',
      identifier:"",
      company_name:'',
      company_url:'',
      company_logo:'',
  })
   
  const handleChange6 = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    setBasesalaryData((prevalue) => {
      return {
        ...prevalue,   // Spread Operator              
        [name]: value
      }
    })
  }
  const urlPatternValidation = URL => {
    const regex = new RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');    
    return regex.test(URL);
  };
  const handleChange5 = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    if(name==='company_url'){
      let isTrueImage = !value || urlPatternValidation(value);
      if(isTrueImage === false)
      {
        setCompanyUrl(true);
      }
      else{
        setCompanyUrl(false);
      }
    }
    setInputFieldsJp((prevalue) => {
      return {
        ...prevalue,   // Spread Operator              
        [name]: value
      }
    }) 
    if(name=== 'country')
    {
      countryData.data.map(function(item, i){
        if(item.iso2 === value)
        {
          setStateData((prevState) => ({
            ...prevState,
            data: item.states
          }));
        }
        return item;
      })
    }
  }
  function MyButton(props) {
    return <button {...props} />
  }
  
  const onCopy = React.useCallback(() => {
    setCopied(true);
    setTimeout(function(){
      setCopied(false);  
    },3000);
  }, [])
  const TELECOMMUTEss = checked===true?`"jobLocationType":  "TELECOMMUTE",
      "applicantLocationRequirements": {
            "@type": "Country",
            "name": "`+inputFieldsJp.country+`"
        },`:''; 
  const jobloc = checked=== false?`"jobLocation": {
            "@type": "Place",
            "address": {
                  "@type": "PostalAddress",
                  "streetAddress": "`+inputFieldsJp.street+`",
                  "addressRegion": "`+inputFieldsJp.state+`",
                  "addressLocality": "`+inputFieldsJp.city+`",
                  "postalCode": "`+inputFieldsJp.zipcode+`",
                  "addressCountry": "`+inputFieldsJp.country+`"
            }
        },`:'';
  const JpIsMyCopy = 
    `<script type="application/ld+json">
    {
      "@context": "https://schema.org/", 
      "@type": "JobPosting", 
      "title": "`+inputFieldsJp.job_title+`",
      "description": "`+inputFieldsJp.description+`",
      "identifier": {
          "@type": "PropertyValue",
          "name": "`+inputFieldsJp.company_name+`",
          "value": "`+inputFieldsJp.identifier+`"
        },
      "hiringOrganization" : {
        "@type": "Organization",
        "name": "`+inputFieldsJp.company_name+`",
        "sameAs": "`+inputFieldsJp.company_url+`",
        "logo": "`+inputFieldsJp.company_logo+`"
      },
      "industry": "`+inputFieldsJp.industry+`",
      "employmentType": "`+inputFieldsJp.employmentType+`",
      "workHours": "`+inputFieldsJp.workHours+`",
      "datePosted": "`+inputFieldsJp.datePosted+`",
      "validThrough": "`+inputFieldsJp.validThrough+`",
      `+TELECOMMUTEss+`
      `+jobloc+`
      "baseSalary": {
        "@type": "MonetaryAmount",
        "currency": "`+basesalayData.currency+`",
        "value": {
                  "@type": "QuantitativeValue",
                  "minValue": "`+basesalayData.minsalary+`",
                  "maxValue": "`+basesalayData.maxsalary+`",
                  "unitText": "`+basesalayData.unitText+`"
            }
        } ,
        "responsibilities": "`+inputFieldsJp.responsibilities+`",
        "skills": "`+inputFieldsJp.skills+`",
        "qualifications": "`+inputFieldsJp.qualifications+`",
        "educationRequirements": "`+inputFieldsJp.educationRequirements+`",
        "experienceRequirements": "`+inputFieldsJp.experienceRequirements+`"
      }
    </script><!--Job Posting Code Generated by https://w3speedup.com/tools/schema-markup-generator/ -->`;

    const resetFun = () =>{
      const resetdata = {
        type: "JobPosting",
        job_title: '',
        description:'',
        hiringOrganization,   
        industry:'',
        employmentType:'',
        workHours:'',
        datePosted:'',
        validThrough:'',
        applicantLocationRequirements,
        jobLocationType:'',
        jobLocation: {
          "@type": "Place",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "",
            "addressLocality": "",
            "postalCode": "",
            "addressCountry": ""
          }
        } ,
        baseSalary: {
          "@type": "MonetaryAmount",
          "currency": "",
          "value": {
            "@type": "QuantitativeValue",
            "minValue": 0,
            "maxValue": 0,
            "unitText": ''
          }
        },
        responsibilities:'',
        skills:'',
        qualifications:'',
        educationRequirements:'',
        experienceRequirements:'',
        street: "",
        city: "",
        zipcode: "",
        country: "",
        state:'',
        identifier:"",
        company_name:'',
        company_url:'',
        company_logo:'',
      };
      setInputFieldsJp(resetdata);
      const resetData1 = ({
        currency:'',
        maxsalary:'',
        minsalary:'',
        unitText:'',
      }); 
      setBasesalaryData(resetData1);
      console.log("inputFieldsJp:::",inputFieldsJp)
    }

    return (
        <div className='row mt-5 jobposting_row'>
          <div className='col-md-8 mb-5 border ps-0'>
            <div className='mt-2 mb-2 article_title'> <i className="fa-solid fa-briefcase me-3"></i><b>Job Posting</b> </div>
              <div className="row input_fields d-flex">
                <div className="col-md-6 pe-0">
                  <div className="form-group me-2 mb-2">
                    <label>Job Title</label>
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp.job_title} name="job_title" className="form-control"/>
                  </div>
                </div>
                <div className="col-md-6 ps-0">
                  <div className="form-group me-2 mb-2">
                  <label>Identifier</label>
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp.identifier} name="identifier" className="form-control"/>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group me-2 mb-2">
                  <label>Description</label>
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp.description} name="description" className="form-control" />
                  </div>
                </div>
                <div className="col-md-6 pe-0">
                  <div className="form-group me-2 mb-2">
                  <label>Company</label>
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp.company_name} name="company_name" className="form-control"/>
                  </div>
                </div>
                <div className="col-md-6 ps-0">
                  <div className="form-group me-2 mb-2">
                  <label>Company URL</label>
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp.company_url} name="company_url" className="form-control"/>
                    {isTrueCompanyurl && (
                      <div style={{ color: "#F61C04" }}>Invalid URL.</div>
                    )}
                  </div>
                </div>
                <div className="col-md-6 pe-0">
                  <div className="form-group me-2 mb-2">
                  <label>Company Logo</label>
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp.company_logo} name="company_logo" className="form-control"/>
                  </div>
                </div>
                <div className="col-md-6 ps-0">
                  <div className="form-group me-2 mb-2">
                  <label>Industry</label>
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp.industry} name="industry" className="form-control" />
                  </div>
                </div>
                <div className="col-md-6 pe-0">
                  <div className="form-group me-2 mb-2">
                  <label>EmploymentType </label>
                  <select onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp.employmentType} name="employmentType" className="form-control">
                    <option value="">Select</option>
                    <option value="FULL_TIME">
                            Full Time
                        </option><option value="PART_TIME">
                            Part Time
                        </option><option value="CONTRACTOR">
                            Contractor
                        </option><option value="TEMPORARY">
                            Temporary
                        </option><option value="INTERN">
                            Intern
                        </option><option value="VOLUNTEER">
                            Volunteer
                        </option><option value="PER_DIEM">
                            Per diem
                        </option><option value="OTHER">
                            Other
                        </option>
                  </select> 
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group me-2 mb-2">
                  <label>Work hours (e.g. 8am-5pm, shift)</label>
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp.workHours} name="workHours" className="form-control"/>
                  </div>
                </div>
                <div className="col-md-6 pe-0">
                  <div className="me-2 mt-2 mb-2">
                  <label><i className="fa-solid fa-calendar-days ms-1 "></i> Post Date</label>
                    <input type="date" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp.datePosted} name="datePosted" className="form-control" />
                  </div>
                </div>
                <div className="col-md-6 ps-0">
                  <div className=" me-2 mt-2 mb-2">
                    <label><i className="fa-solid fa-calendar-week ms-1"></i> Valid Through Date</label>
                    <input type="date" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp.validThrough} name="validThrough" className="form-control" />
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="form-group me-2 mb-2 ">
                    <label>
                      <input type="checkbox" className='me-2' checked={checked}  onChange={handleChangeCheckbox} />
                        Remote job
                    </label>
                  </div>
                </div>
                <div className="col-md-6 pe-0">
                  <div className="form-group me-2 mb-2">
                  <label>Country</label>
                    <select className='form-control' name="country" onChange={handleChange5}>
                      <option>
                        Select Country
                      </option>
                      { country_currency.countries.country.map((calculatedata, index) => {
                          return (
                              <option key={index} value={calculatedata.countryCode}>
                                  {calculatedata.countryName} 
                              </option>)})
                      }
                    </select>
                    <i className="fa-solid fa-chevron-down"></i>
                  </div>
                </div>
                <div className="col-md-6 ps-0">
                  <div className="form-group me-2 mb-2">
                  <label>State/Province/Region</label>
                      <select className='form-control' name="state" onChange={handleChange5}>
                        <option>
                          Select State
                        </option>
                        {stateData.data && stateData.data.map((data, index) => {
                            return <option key={index} value={data.name}>{data.name}</option>
                          })
                         }
                      </select>
                      <i className="fa-solid fa-chevron-down"></i>
                    </div>
                </div>
                <div className="col-md-4 pe-0"> 
                  <div className="form-group me-2 mb-2">
                  <label>Street</label>
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} name="street" className="form-control"  disabled={checked} />
                  </div>
                </div>
                <div className="col-md-4 ps-0 pe-0">
                  <div className="form-group me-2 mb-2">
                  <label>City</label>
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} name="city" className="form-control"disabled={checked} />
                  </div>
                </div>
                <div className="col-md-4 ps-0">
                  <div className="form-group me-2 mb-2">
                  <label>Zipcode</label>
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} name="zipcode" className="form-control" disabled={checked} />
                  </div>
                </div>
                <div className="col-md-6 pe-0">
                  <div className="form-group me-2 mb-2">
                  <label>Salary Min</label>
                    <input type="text" onChange={(evnt) => handleChange6(evnt)} name="minsalary" className="form-control" />
                  </div>
                </div>
                <div className="col-md-6 ps-0">
                  <div className="form-group me-2 mb-2">
                  <label>Salary Max</label>
                    <input type="text" onChange={(evnt) => handleChange6(evnt)} name="maxsalary" className="form-control" />
                  </div>
                </div>
                <div className="col-md-6 pe-0">
                  <div className="form-group me-2 mb-2">
                      <select className='form-control' name="currency" onChange={handleChange6}>
                        <option>
                          Select Currency
                        </option>
                        { country_currency.countries.country.map((calculatedata, index) => {
                            return (
                                <option key={index} value={calculatedata.currencyCode}>
                                    {calculatedata.countryName} {calculatedata.currencyCode}
                                </option>)})
                        }
                      </select>
                      <i className="fa-solid fa-chevron-down"></i>
                  </div>
                </div>
                <div className="col-md-6 ps-0">
                  <div className="form-group me-2 mb-2">
                    <select className='form-control' name="unitText" value={inputFieldsJp.unitText} onChange={handleChange6}>
                      <option>
                        Select Per...
                      </option>
                      <option value="hour">Hour</option>
                      <option value="week">Week</option>
                      <option value="month">Month</option>
                      <option value="year">Year</option>
                    </select>
                    <i className="fa-solid fa-chevron-down"></i>
                  </div>
                </div>
                <div className="col-md-4 pe-0">
                  <div className="form-group me-2 mb-2">
                  <label>Responsibilities</label>
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp.responsibilities} name="responsibilities" className="form-control" />
                  </div>
                </div>
                <div className="col-md-4 ps-0 pe-0">
                  <div className="form-group me-2 mb-2">
                  <label>Skills </label>
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp.skills} name="skills" className="form-control" />
                  </div>
                </div>
                <div className="col-md-4 ps-0">
                  <div className="form-group me-2 mb-2">
                  <label>Qualifications</label>
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp.qualifications} name="qualifications" className="form-control"/>
                  </div>
                </div>
                <div className="col-md-6 pe-0">
                  <div className="form-group me-2 mb-2">
                  <label>Education Requirements</label>
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp.educationRequirements} name="educationRequirements" className="form-control" />
                  </div>
                </div>
                <div className="col-md-6 ps-0">
                  <div className="form-group me-2 mb-2">
                  <label>Experience Requirements</label>
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp.experienceRequirements} name="experienceRequirements" className="form-control"  />
                  </div>
                </div>
              </div>
            </div>
          <div className='col-md-4'>
           <div className="card">
             <div className="card-header d-flex">
               <CopyToClipboard onCopy={onCopy} text={JpIsMyCopy} >
                 <MyButton className="btn btn-success"><i className="fa-solid fa-copy"></i> Copy</MyButton>
               </CopyToClipboard>
               
                 <MyButton className="btn btn-success" onClick={()=>resetFun()}><i className="fa-solid fa-arrows-rotate me-1"></i> Reset</MyButton> 
             </div>
             <div className="card-body">
               {JpIsMyCopy}
             </div>
             {copied && 
               <div className="card-footer text-muted">
                 <div className="p-2 btn-success rounded">✅ copied successfully</div>
               </div>
             }
           </div>
          </div>
        </div>
  );
}

export default Jobposting